export const ADMIN_PATH_PREFIX = '/admin'

export const adminHomePath = (): string => ADMIN_PATH_PREFIX

export const isAdminSurface = (pathname: string): boolean =>
  pathname === ADMIN_PATH_PREFIX || pathname.startsWith(`${ADMIN_PATH_PREFIX}/`)
